import { Dialog, Box, Stack, Typography, Button } from "@mui/material";
import { Archive } from "lucide-react";
import { colors } from "./Pipeline.styles";

const ArchiveLeadsModal = ({ open, onClose, columnTitle, leadsCount, onConfirm }) => {
  const handleArchive = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 4,
          maxWidth: 420,
          width: "100%",
        },
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        {/* Icon */}
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            bgcolor: "#FEE2E2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 3,
          }}
        >
          <Archive size={28} color="#EF4444" />
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 700,
            color: colors.textPrimary,
            mb: 2,
          }}
        >
          Archive All Leads in Column?
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontSize: 13,
            color: colors.textSecondary,
            lineHeight: 1.6,
            mb: 4,
          }}
        >
          This will move all <strong>{leadsCount} leads</strong> from the{" "}
          <strong>'{columnTitle}'</strong> column to the archive, where they can
          still be accessed if needed.
        </Typography>

        {/* Action Buttons */}
        <Stack spacing={2}>
          <Button
            variant="contained"
            onClick={handleArchive}
            fullWidth
            sx={{
              py: 1.5,
              fontSize: 14,
              fontWeight: 600,
              textTransform: "none",
              bgcolor: colors.primary,
              color: "#FFFFFF",
              borderRadius: 2.5,
              boxShadow: "none",
              "&:hover": {
                bgcolor: colors.primaryDark,
                boxShadow: "none",
              },
            }}
          >
            Archive All
          </Button>
          <Button
            variant="text"
            onClick={onClose}
            fullWidth
            sx={{
              py: 1.5,
              fontSize: 14,
              fontWeight: 600,
              textTransform: "none",
              color: colors.textSecondary,
              borderRadius: 2.5,
              "&:hover": {
                bgcolor: colors.bgPrimary,
              },
            }}
          >
            Cancel
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default ArchiveLeadsModal;
